/**
 * TicketMedioWidget — Ticket medio dos orcamentos aprovados/convertidos.
 */
import React from "react";
import { Link } from "react-router-dom";

import { obterPainel } from "../../../services/comercialPainel";

import { CardBody, KpiValor, KpiSub, LinkLight, CardFooter } from "../styles";


export const meta = {
  id: "ticket_medio",
  label: "Ticket medio",
  descricao: "Valor medio dos orcamentos APROVADOS/CONVERTIDOS no periodo.",
  categoria: "Comercial",
  permissoes: ["comercial:metricas"],
  tamanho_default: "S",
  essencial: false,
};

export async function fetchData(request) {
  return await obterPainel(request);
}

function fmt(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return "—";
  return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 });
}

export function Widget({ dados }) {
  const tm = dados?.ticket_medio ?? null;
  return (
    <>
      <CardBody>
        <KpiValor>{fmt(tm)}</KpiValor>
        <KpiSub>média dos orçamentos aprovados (90d)</KpiSub>
      </CardBody>
      <CardFooter>
        <LinkLight as={Link} to="/comercial/painel">Ver painel</LinkLight>
      </CardFooter>
    </>
  );
}
